module.exports = __webpack_public_path__ + "static/img/policeNew.5b51868.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policeNew.png
// module id = 9gk6
// module chunks = 1